import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Sparkle } from '@phosphor-icons/react';

export const SERVICE_COLOR_MAP = {
  blue: {
    bg: 'bg-blue-50 dark:bg-blue-500/20',
    text: 'text-blue-700 dark:text-blue-300',
    border: 'border-blue-200 dark:border-blue-700',
    gradient: 'from-blue-800 via-cyan-700 to-slate-900',
    title: 'bg-gradient-to-r from-slate-900 via-blue-800 to-cyan-700 dark:from-cyan-300 dark:via-blue-300 dark:to-sky-200 bg-clip-text text-transparent',
    chip: 'bg-slate-50 dark:bg-dark-700 text-slate-800 dark:text-slate-200 border border-slate-200/80 dark:border-white/10'
  },
  purple: {
    bg: 'bg-purple-50 dark:bg-purple-500/20',
    text: 'text-purple-700 dark:text-purple-300',
    border: 'border-purple-200 dark:border-purple-700',
    gradient: 'from-purple-900 via-violet-800 to-slate-900',
    title: 'bg-gradient-to-r from-slate-900 via-purple-800 to-fuchsia-800 dark:from-fuchsia-300 dark:via-purple-300 dark:to-violet-200 bg-clip-text text-transparent',
    chip: 'bg-slate-50 dark:bg-dark-700 text-slate-800 dark:text-slate-200 border border-slate-200/80 dark:border-white/10'
  },
  pink: {
    bg: 'bg-pink-50 dark:bg-pink-500/20',
    text: 'text-pink-800 dark:text-pink-300',
    border: 'border-pink-200 dark:border-pink-700',
    gradient: 'from-rose-900 via-pink-800 to-slate-900',
    title: 'bg-gradient-to-r from-slate-900 via-rose-800 to-pink-700 dark:from-pink-300 dark:via-rose-300 dark:to-fuchsia-200 bg-clip-text text-transparent',
    chip: 'bg-slate-50 dark:bg-dark-700 text-slate-800 dark:text-slate-200 border border-slate-200/80 dark:border-white/10'
  },
  orange: {
    bg: 'bg-orange-50 dark:bg-orange-500/20',
    text: 'text-orange-800 dark:text-orange-300',
    border: 'border-orange-200 dark:border-orange-700',
    gradient: 'from-orange-900 via-amber-800 to-slate-900',
    title: 'bg-gradient-to-r from-slate-900 via-orange-800 to-amber-700 dark:from-amber-300 dark:via-orange-300 dark:to-yellow-200 bg-clip-text text-transparent',
    chip: 'bg-slate-50 dark:bg-dark-700 text-slate-800 dark:text-slate-200 border border-slate-200/80 dark:border-white/10'
  },
  teal: {
    bg: 'bg-teal-50 dark:bg-teal-500/20',
    text: 'text-teal-800 dark:text-teal-300',
    border: 'border-teal-200 dark:border-teal-700',
    gradient: 'from-teal-900 via-cyan-800 to-slate-900',
    title: 'bg-gradient-to-r from-slate-900 via-teal-800 to-cyan-700 dark:from-teal-300 dark:via-cyan-300 dark:to-emerald-200 bg-clip-text text-transparent',
    chip: 'bg-slate-50 dark:bg-dark-700 text-slate-800 dark:text-slate-200 border border-slate-200/80 dark:border-white/10'
  },
  indigo: {
    bg: 'bg-indigo-50 dark:bg-indigo-500/20',
    text: 'text-indigo-800 dark:text-indigo-300',
    border: 'border-indigo-200 dark:border-indigo-700',
    gradient: 'from-indigo-900 via-blue-800 to-slate-900',
    title: 'bg-gradient-to-r from-slate-900 via-indigo-800 to-blue-700 dark:from-indigo-300 dark:via-blue-300 dark:to-sky-200 bg-clip-text text-transparent',
    chip: 'bg-slate-50 dark:bg-dark-700 text-slate-800 dark:text-slate-200 border border-slate-200/80 dark:border-white/10'
  },
  red: {
    bg: 'bg-red-50 dark:bg-red-500/20',
    text: 'text-red-800 dark:text-red-300',
    border: 'border-red-200 dark:border-red-700',
    gradient: 'from-red-900 via-rose-800 to-slate-900',
    title: 'bg-gradient-to-r from-slate-900 via-red-800 to-rose-700 dark:from-red-300 dark:via-rose-300 dark:to-orange-200 bg-clip-text text-transparent',
    chip: 'bg-slate-50 dark:bg-dark-700 text-slate-800 dark:text-slate-200 border border-slate-200/80 dark:border-white/10'
  },
  cyan: {
    bg: 'bg-cyan-50 dark:bg-cyan-500/20',
    text: 'text-cyan-800 dark:text-cyan-300',
    border: 'border-cyan-200 dark:border-cyan-700',
    gradient: 'from-cyan-900 via-brand-800 to-slate-900',
    title: 'bg-gradient-to-r from-slate-900 via-cyan-800 to-brand-700 dark:from-cyan-300 dark:via-brand-300 dark:to-sky-200 bg-clip-text text-transparent',
    chip: 'bg-slate-50 dark:bg-dark-700 text-slate-800 dark:text-slate-200 border border-slate-200/80 dark:border-white/10'
  },
  green: {
    bg: 'bg-green-50 dark:bg-green-500/20',
    text: 'text-green-800 dark:text-green-300',
    border: 'border-green-200 dark:border-green-700',
    gradient: 'from-green-900 via-emerald-800 to-slate-900',
    title: 'bg-gradient-to-r from-slate-900 via-green-800 to-emerald-700 dark:from-emerald-300 dark:via-green-300 dark:to-lime-200 bg-clip-text text-transparent',
    chip: 'bg-slate-50 dark:bg-dark-700 text-slate-800 dark:text-slate-200 border border-slate-200/80 dark:border-white/10'
  }
};

export const getServiceColors = (color) => SERVICE_COLOR_MAP[color] || SERVICE_COLOR_MAP.blue;

const ServiceContent = ({ service, headingLevel = 'h2', onCtaClick, hideHero = false }) => {
  const colors = getServiceColors(service.color);
  const TitleTag = headingLevel;
  const [activeIndex, setActiveIndex] = useState(0);
  const [picked, setPicked] = useState({});
  const activeSection = service.sections[activeIndex] || service.sections[0];

  const toggleItem = (item) => {
    setPicked((prev) => ({ ...prev, [item]: !prev[item] }));
  };

  return (
    <article>
      {!hideHero && (
      <div className="relative overflow-hidden rounded-2xl md:rounded-3xl h-48 sm:h-56 md:h-72">
        <img
          src={service.image}
          alt={`${service.title} services by Growmore IT Services`}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent" />
        <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 text-white text-xs font-semibold tracking-wide uppercase backdrop-blur-md mb-3">
            <Sparkle className="w-3.5 h-3.5" weight="fill" />
            Growmore IT Services
          </span>
          <TitleTag className="text-display text-2xl sm:text-3xl md:text-4xl font-extrabold text-white leading-tight">
            {service.title}
          </TitleTag>
        </div>
      </div>
      )}

      <div className={hideHero ? 'space-y-5 sm:space-y-7 min-w-0' : 'mt-8 space-y-5 sm:space-y-7 min-w-0'}>
        <header className="min-w-0">
          <p className="text-body text-sm sm:text-base md:text-lg leading-relaxed break-words">{service.description}</p>
        </header>

        <div className="flex flex-wrap gap-2 min-w-0">
          {service.sections.map((section, index) => (
            <button
              key={section.title}
              type="button"
              onClick={() => setActiveIndex(index)}
              className={`px-3 py-1.5 sm:px-3.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold smooth-transition text-left leading-snug max-w-full whitespace-normal break-words ${
                activeIndex === index
                  ? `text-white bg-gradient-to-r ${colors.gradient} shadow-medium`
                  : 'bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300'
              }`}
            >
              {section.title}
            </button>
          ))}
        </div>

        <section aria-labelledby={`${service.slug}-active-section`} className="min-w-0">
          <h4
            id={`${service.slug}-active-section`}
            className="text-display text-base sm:text-lg font-extrabold text-gray-900 dark:text-white mb-3 sm:mb-4 flex items-start gap-2 min-w-0"
          >
            <span className={`mt-1 w-1.5 h-5 rounded-full shrink-0 bg-gradient-to-b ${colors.gradient}`} />
            <span className="break-words leading-snug min-w-0">
              {activeSection.title}
              <span className="text-xs font-semibold text-gray-400 ml-1">({activeSection.items.length})</span>
            </span>
          </h4>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
            {activeSection.items.map((item) => {
              const selected = Boolean(picked[item]);
              return (
                <li key={item} className="min-w-0">
                  <button
                    type="button"
                    onClick={() => toggleItem(item)}
                    className={`w-full min-w-0 text-left flex items-start gap-2.5 px-3 py-2.5 sm:px-3.5 sm:py-3 rounded-xl text-sm font-medium leading-snug ${
                      selected
                        ? `text-white bg-gradient-to-r ${colors.gradient}`
                        : colors.chip
                    }`}
                  >
                    <CheckCircle className={`w-4 h-4 mt-0.5 shrink-0 ${selected ? 'text-white' : colors.text}`} weight="fill" />
                    <span className="break-words min-w-0">{item}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </section>

        {!hideHero && (
        <Link
          to="/contact"
          onClick={onCtaClick}
          className="btn-primary text-white inline-flex items-center gap-2 px-8 py-3.5"
        >
          Start a Project
          <ArrowRight className="w-5 h-5" weight="bold" />
        </Link>
        )}
      </div>
    </article>
  );
};

export default ServiceContent;
